import { Injectable, Signal, Type, inject } from '@angular/core';
import { Router } from '@angular/router';
import { EnumerationTypeDto } from '@digiwall/core/proxy';
import {
  PlanningDataSource,
  PlanningItemDto,
  ProductionFolderPlanningService,
} from '@digiwall/goliath-documents/proxy';
import { GoliathDocumentsEnumerationTypeStore } from '../../../enumeration-types/enumeration-type.store';
import { BasePlanningAdapter } from '../base-planning.adapter';
import { PlanningDataSourceAdapter } from '../planning-adapter';
import { ProductionFolderBoardFilterComponent } from './production-folder-board-filter.component';
import { ProductionFolderPlanningCardComponent } from './production-folder-planning-card.component';
import {
  PRODUCTION_FOLDER_CARD_FIELDS,
  ProductionFolderPlanningItemFieldsDto,
} from './production-folder-planning-item-fields';
import { PlanningCardFieldDescriptor } from '../planning-card-field';

/** Planning adapter for ProductionFolder documents. */
@Injectable({ providedIn: 'root' })
export class ProductionFolderPlanningAdapter
  extends BasePlanningAdapter
  implements PlanningDataSourceAdapter
{
  private readonly router = inject(Router);
  private readonly store = inject(GoliathDocumentsEnumerationTypeStore);

  readonly dataSource = PlanningDataSource.Production;
  readonly cardComponent: Type<unknown> = ProductionFolderPlanningCardComponent;
  readonly boardFilterComponent: Type<unknown> = ProductionFolderBoardFilterComponent;
  readonly statusEnumeration: Signal<EnumerationTypeDto[]> = this.store.workOrderStatus;
  readonly cardFields: PlanningCardFieldDescriptor[] = PRODUCTION_FOLDER_CARD_FIELDS;

  constructor() {
    super(inject(ProductionFolderPlanningService));
  }

  searchText(dto: PlanningItemDto): string {
    const fields = (dto.displayFields ?? {}) as ProductionFolderPlanningItemFieldsDto;
    return [fields.displayNumber, fields.customer, fields.manufacturer, fields.responsible]
      .filter(Boolean)
      .join(' ');
  }

  openItem(dto: PlanningItemDto): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/', 'production', 'folder-docs', dto.id]),
    );
    window.open(url, '_blank');
  }
}
